module.exports = __webpack_public_path__ + "static/media/logo.dc906c35.png";